import React from 'react';
import {
  CheckoutUserDataConnectorApollo,
  SalePaymentSaveConnectorApollo,
  SaveOnboardingSettingsConnectorApollo,
} from '@front-activerse/common-components';
import SavePaymentContainer from './SavePaymentContainer';

interface ISavePaymentPage {
  pathPaymentMethods: string;
}

const SavePaymentPage: React.FC<ISavePaymentPage> = ({ pathPaymentMethods }) => {
  const tokenFromLocalStorage = localStorage.getItem('shoppingCartToken') || '';

  return (
    <div>
      {tokenFromLocalStorage && (
        <CheckoutUserDataConnectorApollo>
          {({ ...userData }) => (
            <SalePaymentSaveConnectorApollo>
              {({ savePayment, loading }) => (
                <SaveOnboardingSettingsConnectorApollo>
                  {({ saveOnboardingSettings }) => (
                    <SavePaymentContainer
                      {...userData}
                      loading={userData.loading || loading}
                      shoppingCartToken={tokenFromLocalStorage}
                      pathPaymentMethods={pathPaymentMethods}
                      savePayment={savePayment}
                      saveOnboardingSettings={saveOnboardingSettings}
                    />
                  )}
                </SaveOnboardingSettingsConnectorApollo>
              )}
            </SalePaymentSaveConnectorApollo>
          )}
        </CheckoutUserDataConnectorApollo>
      )}
    </div>
  );
};

export default SavePaymentPage;
